import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import fetchAPI from 'utils/http/fetchAPI';
var isUserAuthorized = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId, url, method) {
    var queryParams;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = new URLSearchParams({
              url: url,
              method: method
            });
            _context.next = 3;
            return fetchAPI("/v2/access/".concat(experimentId, "/check?").concat(queryParams), {
              method: 'GET'
            });
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function isUserAuthorized(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default isUserAuthorized;